import { fetchConToken } from "../helpers/fetch";

const ContratacionesService = {
  traerEfectorIngreo: (data) => {
    return fetchConToken(`EfectorFacturacion/BusquedaPorIdTipoEfector/${data.idTipoEfector}?parametros=${data.parametro}&nuevo=${data.nuevo}`);
  },
  traerEfectorPorId: (id) => {
    return fetchConToken(`EfectorFacturacion/${id}`);
  },
  guardarEfectorFacturacion: (data) => {
    return fetchConToken(`EfectorFacturacion`, data, "POST");
  },
  actualizarEfectorFacturacion: (id, efectorFacturacion) => {
    return fetchConToken(`EfectorFacturacion/${id}`, efectorFacturacion, "PUT");
  },

  // -- CONTACTOS --
  traerContactos: (idContacto) => {
    return fetchConToken(`ContactosEfector/${idContacto}`);
  },
  guardarContacto: (contacto) => {
    return fetchConToken(`ContactosEfector`, contacto, "POST");
  },
  actualizarContacto: (idContacto, contacto) => {
    return fetchConToken(`ContactosEfector/${idContacto}`, contacto, "PUT");
  },
  borrarContacto: (idContacto) => {
    return fetchConToken(`ContactosEfector/${idContacto}`, {}, "DELETE");
  },
  traerObservacionesContactos: (idEfectorFacturacion) => {
    return fetchConToken(`EfectorContactosObservaciones/EfectorFacturacion/${idEfectorFacturacion}`);
  },
  guardarObservacionesContacto: (observacionContacto) => {
    return fetchConToken(`EfectorContactosObservaciones`, observacionContacto, "POST");
  },
  borrarObservacionesContacto: (idEfectorContactoObservacion) => {
    return fetchConToken(`EfectorContactosObservaciones/${idEfectorContactoObservacion}`, {}, "DELETE");
  },

  // -- DATOS BANCARIOS --
  guardarDatosBancarios: (datosContables) => {
    return fetchConToken(
      `EfectorFacturacionDatosBancarios`,
      datosContables,
      "POST"
    );
  },
  actualizarDatosBancarios: (idDatosBancarios, datosContables) => {
    return fetchConToken(
      `EfectorFacturacionDatosBancarios/${idDatosBancarios}`,
      datosContables,
      "PUT"
    );
  },
  obtenerDatosBancarios: (idEfectorFacturacion) => {
    return fetchConToken(
      `EfectorFacturacionDatosBancarios/${idEfectorFacturacion}`
    );
  },
  obtenerDatosJudiciales: (idEfectorFacturacion) => {
    return fetchConToken(
      `EfectorFacturacionDatosBancarios/cuentaJudicial/${idEfectorFacturacion}`
    );
  },
  guardarCuentasContables: (data) => {
    return fetchConToken(
      `EfectorFacturacionDatosBancarios/CuentasContables`,
      data,
      "POST"
    );
  },
  guardarCuentaJudicial: (data) => {
    
    return fetchConToken(
      `EfectorFacturacionDatosBancarios/CuentaJudicial`,
      data,
      "PUT"
    );
  },
  actualizarCuentasContables: (data) => {
    return fetchConToken(
      `EfectorFacturacionDatosBancarios/CuentasContables`,
      data,
      "PUT"
    );
  },
  deleteCuentasContables: (id) => {
    return fetchConToken(
      `EfectorFacturacionDatosBancarios/CuentasContables/${id}`,
      { id },
      "DELETE"
    );
  },
  obtenerCuentasContables: (idEfectorFacturacion) => {
    return fetchConToken(
      `EfectorFacturacionDatosBancarios/CuentasContables/${idEfectorFacturacion}`
    );
  },

  //DOCUMENTACION
  obtenerDocumentacionXSubTipoEfector: (idSubTipoEfector) => {
    return fetchConToken(
      `TipoDocumentacionesPorSubTipoEfector/${idSubTipoEfector}`
    );
  },
  obtenerDocumentacionXPorEfector: (idEfectorFacturacion) => {
    return fetchConToken(
      `EfectorFacturacionDocumentacion/${idEfectorFacturacion}`
    );
  },
  eliminarDocumentacionXEfector: (
    idTipoDocumentacionesEfectoresPorSubTipoEfector
  ) => {
    return fetchConToken(
      `EfectorFacturacionDocumentacion/${idTipoDocumentacionesEfectoresPorSubTipoEfector}`,
      {},
      "DELETE"
    );
  },
  obtenerDocumentacionLegal: (idEfectorFacturacion) => {
    return fetchConToken(
      `EfectorFacturacionDocumentacionLegal/${idEfectorFacturacion}`
    );
  },
  eliminarDocumentacionLegal: (
    idDocumentacionLegal
  ) => {
    return fetchConToken(
      `EfectorFacturacionDocumentacionLegal/${idDocumentacionLegal}`,
      {},
      "DELETE"
    );
  },


  // -- DATOS CARTILLA --
  traerPrestadores: (idEfectorFacturacion, textoBuscado) => {
    if (textoBuscado === "")
      textoBuscado = null;
    return fetchConToken(`Prestadores/${idEfectorFacturacion}/${textoBuscado}`);
  },
  guardarPrestador: (prestador) => {
    return fetchConToken(`Prestadores`, prestador, "POST");
  },
  actualizarPrestador: (idPrestador, prestador) => {
    return fetchConToken(`Prestadores/${idPrestador}`, prestador, "PUT");
  },
  borrarPrestador: (idPrestador) => {
    return fetchConToken(`Prestadores/${idPrestador}`, {}, "DELETE");
  },
  borrarTodosPrestadores: (idEfectorFacturacion) => {
    return fetchConToken(`Prestadores/EliminarTodosPorContrato/${idEfectorFacturacion}`, {}, "DELETE");
  },
  guardarCartillaPrestador: (cartillaPrestador) => {
    return fetchConToken(`CartillaPrestadores`, cartillaPrestador, "POST");
  },
  actualizarCartillaPrestador: (idCartillaPrestador, cartillaPrestador) => {
    return fetchConToken(`CartillaPrestadores/${idCartillaPrestador}`, cartillaPrestador, "PUT");
  },
  borrarCartillaPrestador: (idCartillaPrestador) => {
    return fetchConToken(`CartillaPrestadores/${idCartillaPrestador}`, {}, "DELETE");
  },
  cargarExcelEfectores: () => {
    return fetchConToken(`EfectoresRedExcel`);
  },
  //REPORTES Cartilla
  generarExcelCartilla: (idEfectorFacturacion) => {
    return fetchConToken(`Prestadores/${idEfectorFacturacion}/GenerarExcel`);
  },
  generarPdfCartilla: (idEfectorFacturacion) => {
    return fetchConToken(`Prestadores/${idEfectorFacturacion}/GenerarPDF`);
  },


  //MODULOS
  traerModulosPorEfectorFacturacion: (idEfectorFacturacion) => {
    return fetchConToken(`Modulos/PracticasPorModulosPorEfector/${idEfectorFacturacion}`);
  },
  guardarModuloPorEfectorFacturacion: (idEfectorFacturacion, data) => {
    return fetchConToken(`Modulos/PracticasPorModulosPorEfector/${idEfectorFacturacion}`, data, "POST");
  },
  eliminarModuloPorEfectorFacturacion: (idEfectorFacturacion, idModulo) => {
    return fetchConToken(`Modulos/PracticasPorModulosPorEfector/${idEfectorFacturacion}/${idModulo}`, {}, "DELETE");
  },
  //REPORTES MODULOS
  generarExcelModulosPorEfectorFacturacion: (idEfectorFacturacion) => {
    return fetchConToken(`Modulos/PracticasPorModulosPorEfector/${idEfectorFacturacion}/GenerarExcel`);
  },
  generarPdfModulosPorEfectorFacturacion: (idEfectorFacturacion) => {
    return fetchConToken(`Modulos/PracticasPorModulosPorEfector/${idEfectorFacturacion}/GenerarPDF`);
  },

  //INCLUSIONES EXCLUSIONES
  traerInclusionesExclusiones: (idEfectorFacturacion) => {
    return fetchConToken(`InclusionesExclusiones/${idEfectorFacturacion}`);
  },
  guardarInclusionesExclusiones: (idEfectorFacturacion, data) => {
    return fetchConToken(`InclusionesExclusiones/${idEfectorFacturacion}`, data, "POST");
  },

  // LEGALES
  traerEstadosLegales: (idEfectorFacturacion) => {
    return fetchConToken(`EfectorEstadosLegales/EfectorFacturacion/${idEfectorFacturacion}`);
  },
  guardarEstadoLegal: (estadoLegal) => {
    return fetchConToken(`EfectorEstadosLegales`, estadoLegal, "POST");
  },
  borrarEstadoLegal: (idEfectorEstadoLegal) => {
    return fetchConToken(`EfectorEstadosLegales/${idEfectorEstadoLegal}`, {}, "DELETE");
  },
  traerAreasLegales: () => {
    return fetchConToken(`EfectorEstadosLegales/AreasLegales`);
  },
  confirmAcuerdoJudicial: (data) => {
    return fetchConToken(`EfectorEstadosLegales/AcuerdoJudicial`, data, 'PUT');
  },

  // -- DATOS VARIOS --
  traerEspecialidades: () => {
    return fetchConToken(`Especialidades`);
  },
  getTiposEfectores: () => {
    return fetchConToken(`TipoEfector`);
  },
  traerRubros: () => {
    return fetchConToken(`Rubros`);
  },
  traerZonas: () => {
    return fetchConToken(`Zonas`);
  },
  traerZonasSegunPractica: (codPractica, conInternacion) => {
    return fetchConToken(`Zonas/traerSegunPracticas/${codPractica}/${conInternacion}`);
  },
  traerCentrosMedicos: () => {
    return fetchConToken(`CentrosMedicosPropios`);
  },
  traerRankingsCartilla: () => {
    return fetchConToken(`RankingsCartilla`);
  },
  traerCartilla: () => {
    return fetchConToken(`Cartilla`);
  },
  traerPlanes: () => {
    return fetchConToken(`PlanesContratos`);
  },
  traerCategorias: () => {
    return fetchConToken(`CategoriasContratos`);
  },
  traerCuentasNomenclador: () => {
    return fetchConToken(`CuentasNomenclador`);
  },
  traerCuentasNomencladorXCod: (codNom) => {
    return fetchConToken(`CuentasNomenclador/${codNom}`);
  },
  traerPlanesCuentas: () => {
    return fetchConToken(`PlanCuentas`);
  },
  traerNomencladorNacional: (todasLasPracticas, codigoNombre) => {
    return fetchConToken(`NomencladorNacional?codigoNombre=${codigoNombre}&todas=${todasLasPracticas}`);
  },
  traerTodasCategoriasEfector: () => {
    return fetchConToken(`CategoriasEfector/Todas`);
  },
  traerBancos: () => {
    return fetchConToken(`NominaBancos`);
  },
  traerTipoPrestador: (idTipoEfector) => {
    return fetchConToken(`SubTipoEfector/traerPorTipoEfector/${idTipoEfector}`);
  },
  traerNomenclador: () => {
    return fetchConToken(`Nomencladores`);
  },
  traerMatriculasTipo: () => {
    return fetchConToken(`TipoMatriculas`);
  },
  traerMotivosBajaEfector: () => {
    return fetchConToken(`MotivosBajaEfector`);
  },
  traerTipoContactoEfector: () => {
    return fetchConToken(`TipoContactoEfectores`);
  },
  traerCondicionIva: () => {
    return fetchConToken(`CondicionIva`);
  },

  //NOMENCLADOR
  crearPractica: (data) => {
    return fetchConToken(`NomencladorNacional`, data, "POST");
  },
  editarPractica: (idPractica, data) => {
    return fetchConToken(`NomencladorNacional/${idPractica}`, data, "PUT");
  },

  //CUENTAS NOMENCLADOR
  crearCuenta: (data) => {
    return fetchConToken(`CuentasNomenclador`, data, "POST");
  },
  editarCuenta: (data) => {
    return fetchConToken(`CuentasNomenclador`, data, "PUT");
  },

  //PRESUPUESTO
  traerPrespuesto: (idPresupuesto) => {
    return fetchConToken(`Presupuestos/traerPorIdPresupuesto/${idPresupuesto}`)
  },

  //MESA ENTRADA
  traerEfectorMesa: (idEfectorFacturacion) => {
    return fetchConToken(`EfectorFacturacion/MesaEntrada/${idEfectorFacturacion}`)
  },

  //COPY CONVENIOS
  copyConvenios: (data) => {
    return fetchConToken(`EfectorFacturacion/CopyConvenio`, data, 'POST')
  },
}
export { ContratacionesService as default };
